<template>
  <mp-drawer :is-open="isSwitchAppOpen" :on-close="onSwitchAppToggle">
    <mp-modal-overlay />
    <mp-drawer-content max-width="xs" border="none" border-left="1px" border-left-color="gray.100" overflow-y="auto">
      <mp-box>
        <mp-drawer-close-button />
      </mp-box>
      <mp-drawer-body padding-bottom="20" padding-x="6" margin-top="16">
        <mp-box v-for="(section, index) in listedApps" :key="index" :data-qa="`component-quick-links-section-${index}`">
          <mp-divider v-if="index > 0" margin-top="2" margin-bottom="2.5" />

          <mp-text margin-bottom="2">{{ section.title }}</mp-text>
          <app-item
            v-for="apps in section.apps"
            :key="apps.name"
            :data-qa="`component-quick-links-app-${apps.name.toLowerCase().replace(/\s+/g, '-')}`"
            :title="apps.name"
            :description="apps.desc"
            :icon="apps.logo"
            @click="openProduct(apps)"
          />
        </mp-box>
      </mp-drawer-body>
    </mp-drawer-content>
  </mp-drawer>
</template>
<script>
import { MpDivider, MpDrawer, MpDrawerBody, MpDrawerCloseButton, MpDrawerContent, MpModalOverlay } from '@mekari/pixel';
import AppItem from '@/components/layouts/AppItem';
import { alertMixin } from '@/mixins/general';

const LISTED_APPS = [
  {
    logo: 'talenta-brand',
    name: 'Mekari Talenta',
    desc: 'Advanced payroll automation & HR solution',
    link: 'https://www.talenta.co/',
  },
];

const OTHER_APPS = [
  {
    logo: 'flex-brand',
    name: 'Mekari Flex',
    desc: 'Flexible employee benefits management',
    link:
      'https://mekari.com/produk/mekari-flex/?utm_source=ecosystem&utm_medium=talenta+%28in-app%29&utm_campaign=talenta+%28in-app%29+-+product+selector',
  },
  {
    logo: 'jurnal-brand',
    name: 'Mekari Jurnal',
    desc: 'Integrated online accounting software',
    link: 'https://www.jurnal.id/id/?utm_source=ecosystem&utm_medium=talenta+%28in-app%29&utm_campaign=talenta+%28in-app%29+-+product+selector',
  },
  {
    logo: 'klikpajak-brand',
    name: 'Mekari Klikpajak',
    desc: 'Simple tax management platform',
    link: 'https://klikpajak.id/?utm_source=ecosystem&utm_medium=talenta%20%28in-app%29&utm_campaign=talenta%20%28in-app%29%20-%20product%20selector',
  },
  {
    logo: 'qontak-brand',
    name: 'Mekari Qontak',
    desc: 'Complete CRM software',
    link: 'https://qontak.com/?utm_source=ecosystem&utm_medium=talenta%20%28in-app%29&utm_campaign=qontak%20%28in-app%29%20product%20selector',
  },
  {
    logo: 'sign-brand',
    name: 'Mekari Sign',
    desc: 'Certified digital signature software',
    link:
      'https://mekarisign.com/id/?utm_source=ecosystem&utm_medium=talenta%20%28in-app%29&utm_campaign=talenta%20%28in-app%29%20-%20product%20selector',
  },
];

const OTHER_FROM_MEKARI = [
  {
    logo: 'mekari-brand',
    name: 'Mekari Launchpad',
    desc: 'All your apps',
    link: 'https://launchpad.mekari.com/marketplace?ref=talenta-performance_review-product_selector  ',
  },
  {
    logo: 'university-brand',
    name: 'Mekari University',
    desc: 'Comprehensive upskilling platform',
    link: 'https://univ.mekari.com/?utm_source=ecosystem&utm_medium=talenta+%28in-app%29&utm_campaign=talenta+%28in-app%29+-+product+selector',
  },
];

export default {
  name: 'QuickLinks',
  components: {
    MpDivider,
    MpDrawer,
    MpDrawerBody,
    MpDrawerCloseButton,
    MpDrawerContent,
    MpModalOverlay,
    AppItem,
  },
  mixins: [alertMixin],
  props: {
    name: {
      type: String,
      required: true,
    },
    isSwitchAppOpen: {
      type: Boolean,
      required: true,
    },
    onSwitchAppToggle: {
      type: Function,
      required: true,
    },
  },
  computed: {
    listedApps() {
      return [
        {
          title: `Hi ${this.name}, your apps are listed here.`,
          apps: LISTED_APPS,
        },
        {
          title: 'Other apps by Mekari that might suit your business needs.',
          apps: OTHER_APPS,
        },
        {
          title: 'Other from Mekari.',
          apps: OTHER_FROM_MEKARI,
        },
      ];
    },
  },
  methods: {
    openProduct(app) {
      this.trackMixpanel(app.name);
      return window.open(app.link, '_blank') || window.location.replace(app.link);
    },
    async trackMixpanel(appName) {
      try {
        const url = `${this.$endPoint}/users/product-click-tracking`;
        await this.$axios.post(url, { product_name: appName });
      } catch (e) {
        this.alertToast('Error to track mixpanel', 'danger');
      }
    },
  },
};
</script>
